const AUTH_USER_KEY = "authUser";
const REMEMBER_ME_KEY = "authRememberMe";

const parseStoredUser = (value) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

class StorageManager {
  constructor(key) {
    this.key = key;
  }
  save(obj, rememberMe) {
    const shouldRemember =
      rememberMe ?? localStorage.getItem(REMEMBER_ME_KEY) === "true";
    const storage = shouldRemember ? localStorage : sessionStorage;

    sessionStorage.removeItem(this.key);
    localStorage.removeItem(this.key);
    storage.setItem(this.key, JSON.stringify(obj));

    if (this.key === AUTH_USER_KEY) {
      localStorage.setItem(REMEMBER_ME_KEY, shouldRemember ? "true" : "false");
    }
  }
  get() {
    return (
      parseStoredUser(sessionStorage.getItem(this.key)) ||
      parseStoredUser(localStorage.getItem(this.key))
    );
  }
  remove() {
    sessionStorage.removeItem(this.key);
    localStorage.removeItem(this.key);

    if (this.key === AUTH_USER_KEY) {
      localStorage.removeItem(REMEMBER_ME_KEY);
    }
  }
}

const setUserData = (user, rememberMe) => {
  const shouldRemember =
    rememberMe ?? localStorage.getItem(REMEMBER_ME_KEY) === "true";
  const storage = shouldRemember ? localStorage : sessionStorage;

  sessionStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  storage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  localStorage.setItem(REMEMBER_ME_KEY, shouldRemember ? "true" : "false");
};

const getLoggedinUser = () => {
  return (
    parseStoredUser(sessionStorage.getItem(AUTH_USER_KEY)) ||
    parseStoredUser(localStorage.getItem(AUTH_USER_KEY))
  );
};

const removeUserData = () => {
  sessionStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(REMEMBER_ME_KEY);
};

export { StorageManager, getLoggedinUser, setUserData, removeUserData };
